// frontend/src/services/notificacionService.js
import apiClient from './apiClient';

const API_URL = '/notificaciones';

const getNotificaciones = () => {
    return apiClient.get(`/notificaciones`);
};

const getPendientes = () => {
    return apiClient.get(`/notificaciones/pendientes`);
};

const marcarComoLeida = (idNotificacion) => {
    return apiClient.put(`/notificaciones/${idNotificacion}/enviar`);
};

const marcarComoLeidaUsuario = (idNotificacion) => {
    return apiClient.patch(`/notificaciones/${idNotificacion}/leer`);
};

// Botón "Marcar todas como leídas" de las campanas. origen es opcional (ej. "ANSES" desde la
// campana de Seguimiento de Expedientes); sin él marca todas las notificaciones del usuario.
const marcarTodasComoLeidas = (origen) => {
    return apiClient.patch(`/notificaciones/leer-todas`, null, { params: origen ? { origen } : {} });
};

const getUltimas = () => {
    return apiClient.get(`/notificaciones/ultimas`);
};

/**
 * Envía una notificación manualmente (inmediata) para un evento.
 * @param {number} idEvento - ID del evento
 * @param {object} opciones - Opciones de destino
 * @param {boolean} opciones.notificarCliente - Si debe notificarse al titular
 * @param {boolean} opciones.notificarContacto - Si debe notificarse al contacto adicional
 */
const enviarNotificacionManual = (idEvento, opciones = {}) => {
    const payload = {
        idEvento,
        notificarCliente: opciones.notificarCliente ?? true,
        notificarContacto: opciones.notificarContacto ?? false,
    };

    console.info('[notificacionService] POST /notificaciones/manual', payload);
    return apiClient.post('/notificaciones/manual', payload);
};

/**
 * Programa notificaciones automáticas para un evento (24h, 5h, 1h antes).
 * @param {number} idEvento - ID del evento
 */
const programarNotificacionesAutomaticas = (idEvento, tiempos = []) => {
    // Enviamos los tiempos en el cuerpo del POST
    return apiClient.post(`/notificaciones/programar/${idEvento}`, {
        horasAntes: tiempos
    });
};

const getEmailsPendientes = () => {
    return apiClient.get('/notificaciones/emails/pendientes');
};

const getEmailsUltimas = () => {
    return apiClient.get('/notificaciones/emails/ultimas');
};

const getCorreos = () => {
    return apiClient.get('/notificaciones/correos');
};

// Historial completo de notificaciones del sistema (SISTEMA/ANSES/WHATSAPP_DESCONEXION)
// del usuario, incluye leídas y no leídas — a diferencia de getPendientes/getUltimas,
// que solo devuelven no leídas. Usado por NotificacionesPage y el panel del Home.
const getHistorial = () => {
    return apiClient.get('/notificaciones/historial');
};

const NotificacionService = {
    getNotificaciones,
    getPendientes,
    marcarComoLeida,
    marcarComoLeidaUsuario,
    marcarTodasComoLeidas,
    getUltimas,
    enviarNotificacionManual,
    programarNotificacionesAutomaticas,
    getEmailsPendientes,
    getEmailsUltimas,
    getCorreos,
    getHistorial,
};

export default NotificacionService;
